import React from 'react';
import { LegalLayout, LegalSection } from '../components/page/LegalLayout';
const sections: LegalSection[] = [{
  heading: 'Introduction',
  blocks: [{
    type: 'p',
    text: "Welcome to Zano's Cookie Policy. This policy explains how we use cookies and similar technologies on our website."
  }]
}, {
  heading: 'What Are Cookies?',
  blocks: [{
    type: 'p',
    text: 'Cookies are small text files that are stored on your device (computer or mobile device) when you visit a website. They are widely used to make websites work more efficiently and to provide information to the owners of the site.'
  }]
}, {
  heading: 'Types of Cookies We Use',
  blocks: [{
    type: 'p',
    text: 'We use the following types of cookies on our website:'
  }, {
    type: 'list',
    items: ['Essential Cookies: These cookies are necessary for the website to function properly. They enable core functionalities such as security, network management, and accessibility.', 'Analytics Cookies: These cookies help us analyze and understand how visitors interact with our website. We use this information to improve our website and services.', 'Functionality Cookies: These cookies allow the website to remember choices you make (such as your username, language, or region) and provide enhanced, more personalized features.']
  }]
}, {
  heading: 'Third-Party Cookies',
  blocks: [{
    type: 'p',
    text: 'Our website may also use cookies from third-party services such as Google Analytics to analyze website traffic and improve our services. These cookies may collect information about your browsing behavior on our website and other websites you visit.'
  }]
}, {
  heading: 'Managing Cookies',
  blocks: [{
    type: 'p',
    text: 'You can manage your cookie preferences through your browser settings. Most browsers allow you to block or delete cookies from your device. Please note that blocking cookies may affect the functionality of the website.'
  }]
}, {
  heading: 'Updates to This Policy',
  blocks: [{
    type: 'p',
    text: 'We may update our Cookie Policy from time to time to reflect changes in our practices and service offerings. We will notify you of any changes by posting the updated policy on our website with an updated effective date.'
  }]
}, {
  heading: 'Contact Us',
  blocks: [{
    type: 'p',
    text: 'If you have any questions about our Cookie Policy or your cookie preferences, please contact us at support@zanoplatform.com.'
  }]
}];
export const CookiePolicy = () => {
  return <LegalLayout title="Cookie Policy" subtitle="Read our policy below to learn more about your rights and responsibilities as a user." updated="July 17, 2024" sections={sections} data-id="element-1996" />;
};